import * as React from 'react';
import * as styles from "./TabBarItem.css";
import { IAIcon } from '../../../icon/Icon';

export interface ITabBarItemProps {
  icon: string;
  title: string;
  iconColor: string;
  titleColor: string;
  style?: React.CSSProperties;
  onClick: () => void;
}

export class TabBarItem extends React.Component<ITabBarItemProps> {

  public render(): JSX.Element {
    return (
      <div
        className={styles.IA_tabBarItem}
        style={this.props.style}
        onClick={() => {
          this.props.onClick();
        }}
      >
        {(this.props.title === undefined || this.props.title === "") ?
          <IAIcon
            title={this.props.icon}
            size={24}
            color={this.props.iconColor}
            style={{
              marginLeft: "calc(50% - 12px)",
              width: 24,
              height: 24, 
              marginTop: 5
            }}
          />
          :
          <div>
            <IAIcon
              title={this.props.icon}
              size={18}
              color={this.props.iconColor}
              style={{
                marginLeft: "calc(50% - 9px)",
                width: 18,
                height: 18
              }}
            />
            <div
              className={styles.IA_title}
              style={{
                color: this.props.titleColor
              }}
            >
              {this.props.title}
            </div>
          </div>
        }
      </div >
    );
  }
}